var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFigoLogo(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 146,
    height: 56,
    viewBox: "0 0 146 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Figo / Logo / Lightbackground",
    clipPath: "url(#clip0_3988_21871)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill-10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.775 42.9459C123.848 42.9459 123.104 42.1933 123.104 41.2788C123.104 40.3577 123.848 39.6102 124.775 39.6102C125.703 39.6102 126.45 40.3577 126.45 41.2788C126.45 42.1933 125.703 42.9459 124.775 42.9459ZM124.674 38.3386H124.668H124.66C120.854 38.3289 118.238 39.0564 117.871 39.1534V39.3852V44.3592C117.871 46.2935 118.524 48.0423 118.524 48.0423C119.796 51.7145 124.34 55.323 124.66 55.5809V55.5912H124.668V55.5866V55.5912H124.674V55.5809C125.001 55.323 129.55 51.7145 130.825 48.0423C130.825 48.0423 131.469 46.2935 131.469 44.3592V39.3852V39.1534C131.107 39.0564 128.485 38.3289 124.674 38.3386Z",
    fill: "#95E6E2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M124.834 42.0571C125.229 42.0571 125.544 41.6182 125.553 41.0818V31.0154H124.122V41.1248C124.148 41.6407 124.451 42.0571 124.834 42.0571Z",
    fill: "#02313D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M123.806 0.265934C110.849 0.265934 101.799 6.81583 101.799 17.1754C101.799 27.3716 111.055 34.7714 123.806 34.7714C124.392 34.7714 124.96 34.7399 125.53 34.7108V29.4624C124.957 29.4999 124.381 29.523 123.806 29.523C115.818 29.523 107.221 25.6592 107.221 17.1754C107.221 8.646 115.551 5.29287 123.806 5.29287C136.047 5.29287 140.391 11.4799 140.391 17.1754C140.391 24.3998 134.412 28.2326 127.568 29.2399V34.5379C138.475 33.27 145.814 26.4971 145.814 17.1754C145.814 6.81583 136.764 0.265934 123.806 0.265934Z",
    fill: "#02313D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M72.4684 17.1064V22.0712H90.1014V26.2661C87.5948 27.4843 81.6764 29.9524 74.5243 29.8585C65.7853 29.7787 58.8509 25.2566 58.8509 16.8831C58.8509 10.1373 64.4047 5.52288 73.4682 5.52288C79.6963 5.52288 87.2024 6.96951 88.9264 12.2817H95.1914C92.9398 3.43877 82.2823 0.265934 73.4682 0.265934C61.3017 0.265934 52.9609 7.14017 52.9609 16.8831C52.9609 28.4917 62.6113 35.0071 74.4722 35.1155C74.5858 35.1165 74.6968 35.1165 74.8088 35.1165C85.7508 35.1165 93.9191 30.2626 94.2652 30.0543L95.5443 29.2818V17.2028V17.1064H88.654H72.4684Z",
    fill: "#02313D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.4365 32.8659H46.162V0.430725H40.4365V32.8659Z",
    fill: "#02313D"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 32.8659H5.90749V21.1272H28.5473V16.1336H5.90749V5.32306H33.6373V0.430725H0V32.8659Z",
    fill: "#02313D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3988_21871"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 146,
    height: 56,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFigoLogo);
export default __webpack_public_path__ + "static/media/figo-logo.d8237f4c03310ed6d0069fb6a958f397.svg";
export { ForwardRef as ReactComponent };